export function normalizeAI(out) {
  if (typeof out === "string") return out;
  return (
    out?.output_text ||
    out?.content ||
    out?.choices?.[0]?.message?.content ||
    JSON.stringify(out || "")
  );
}
export function stripCodeFences(s = "") {
  return String(s)
    .replace(/```(?:json)?/gi, "")
    .replace(/```/g, "")
    .trim();
} // Persist keys
export function safeParseJSON(s) {
  if (!s) return null;
  const txt = stripCodeFences(s);
  try {
    return JSON.parse(txt);
  } catch {
    const start = txt.indexOf("{");
    const end = txt.lastIndexOf("}");
    if (start !== -1 && end !== -1 && end > start) {
      try {
        return JSON.parse(txt.slice(start, end + 1));
      } catch {}
    }
    return null;
  }
}
export default normalizeAI;